import { withInstall } from '@/utils';

import pageFooter from './src/PageFooter.vue';
import pageWrapper from './src/PageWrapper.vue';
import { PageWrapperFixedHeightKey } from './constant';

export const PageFooter = withInstall(pageFooter);
export const PageWrapper = withInstall(pageWrapper);

export { PageWrapperFixedHeightKey };
